<template>
  <div class="user-task-quitting" v-if="viewType === 'quitting'">
    <div class="dialog">
      <div class="content">
        <!-- 还差<span class="h">{{6 - step}}步</span>就可以完成任务，领取<span class="h">新人体验会员</span>了哦。确定要停止任务吗？ -->
        还差<span class="h">{{6 - step}}步</span>就可以完成任务了哦。确定要停止任务吗？
      </div>
      <div class="footer">
        <div class="btn" @click="quit">停止</div>
        <div class="btn confirm" @click="goOn">继续任务</div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters({
      viewType: 'userTask/viewType',
      step: 'userTask/step'
    }),
  },
  methods: {
    goOn () {
      this.$store.commit('userTask/setViewType', 'task');
    },
    quit () {
      this.$store.commit('userTask/setViewType', 'leave');
    }
  }
}
</script>

<style scoped lang="scss">
.user-task-quitting {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#000000, .6);
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 502px;
  height: 228px;
  background: #FFFFFF;
  opacity: 1;
  border-radius: 4px;
  padding: 55px;
}
.content {
  text-align: left;
  .h {
    color: #5778FB;
    font-weight: bold;
    border-bottom: 1px solid #5778FB;
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 40px;
    background: #EAEAF6;
    opacity: 1;
    border-radius: 4px;
    color: #333;
    cursor: pointer;
  }
  .btn.confirm {
    background: #5778FB;
    color: #fff;
    margin-left: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userTask/quittingModal.vue